import { CommonModule } from '@angular/common';
import { LanguageTranslationModule } from './language-translation/language-translation.module';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { KeycloakService } from './services/keycloak.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { initializeKeycloak } from 'src/app/initKeycloak';
import { LoaderService } from './services/loader.service';
import { RequestInterceptor } from './interceptors/request.interceptor';

@NgModule({
    imports: [CommonModule, HttpClientModule, LanguageTranslationModule],
    declarations: [],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            multi: true,
            deps: [KeycloakService],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            deps: [KeycloakService, LoaderService],
            multi: true,
        },
        {
            provide: LoaderService,
        },
    ],
    exports: [HttpClientModule, LanguageTranslationModule],
    bootstrap: [],
})
export class SharedModule {
    constructor() {}
}
